import { createFileRoute, Outlet } from '@tanstack/react-router';

import { PageLayout } from '@/features/page-layout/PageLayout';

export const Route = createFileRoute('/_protected/t/$tenantId/systems')({
  component: SystemsLayout,
});

function SystemsLayout() {
  return (
    <PageLayout classes={{ page: 'flex flex-col !overflow-hidden' }}>
      <div className="min-h-0 min-w-0 flex-1 overflow-auto">
        <Outlet />
      </div>
    </PageLayout>
  );
}
